/**
 * @typedef {string} TradelineType - Can be one of:
 * 'MORTGAGE' or
 * 'AUTO_LOAN' or
 * 'STUDENT_LOAN' or
 * 'PERSONAL_LOAN' or
 * 'HELOC' or
 * 'CREDIT_CARD' or
 * 'LOAN' or
 * 'COLLECTION' or
 * 'OTHERS' or
 * 'CONSTRUCTION' or
 * 'FARM' or
 * 'LOT' or
 * 'REVERSE_MORTGAGE' or
 * 'BUSINESS' or
 * 'HELOAN' or
 * 'SBLINE'
 */

/**
 * Normalizes a tradeline type string by capitalizing the first letter and removing '_loan' suffix
 * @param {TradelineType} tradelineType - The type of tradeline to normalize
 * @param {boolean} [returnLowerCase=false] - Whether to return the normalized tradeline type in lowercase
 * @returns {string} The normalized tradeline type
 * @example
 * normalizeLoanType('MORTGAGE') // 'Mortgage'
 * normalizeLoanType('auto_loan') // 'Auto'
 * normalizeLoanType('student_loan') // 'Student'
 * normalizeLoanType('personal_loan') // 'Personal'
 * normalizeLoanType('heloc') // 'Heloc'
 * normalizeLoanType('credit_card') // 'Credit_card'
 */
const normalizeLoanType = (tradelineType, returnLowerCase = false) => {
	if (!tradelineType) return '';

	const formattedTradelineType =
		tradelineType[0].toUpperCase() + tradelineType.slice(1).toLowerCase();

	const strippedFormattedTradelineType = formattedTradelineType.replace(
		'_loan',
		''
	);

	return returnLowerCase
		? strippedFormattedTradelineType.toLowerCase()
		: strippedFormattedTradelineType;
};

export default normalizeLoanType;
